import type { AnalyticsAggregate } from '../types';

interface AnalyticsKPIsProps {
	data: AnalyticsAggregate;
	timeWindow: string;
}

function fmtNum(n: number): string {
	if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}M`;
	if (n >= 1000) return `${(n / 1000).toFixed(1)}k`;
	return n.toLocaleString();
}

export function AnalyticsKPIs({ data, timeWindow }: AnalyticsKPIsProps) {
	const totalSuccess = data.sent - data.failed;
	const successRate = ((totalSuccess / data.sent) * 100).toFixed(1);

	const kpis = [
		{
			label: 'Total Sent',
			value: fmtNum(data.sent),
			delta: timeWindow === '24h' ? '+8%' : '+12%',
			up: true,
		},
		{
			label: 'Successful',
			value: fmtNum(totalSuccess),
			delta: timeWindow === '24h' ? '+9%' : '+11%',
			up: true,
		},
		{
			label: 'Failed',
			value: fmtNum(data.failed),
			delta: timeWindow === '24h' ? '+2%' : '+3%',
			up: false,
		},
		{
			label: 'Success Rate',
			value: `${successRate}%`,
			delta: timeWindow === '24h' ? '-0.2%' : '+0.4%',
			up: timeWindow !== '24h',
		},
		{
			label: 'Avg Latency',
			value: data.latency,
			delta: '-14ms',
			up: true,
		},
		{
			label: 'Fallback Rate',
			value: data.fallback,
			delta: '-0.3%',
			up: true,
		},
	];

	return (
		<div className="grid grid-cols-6 gap-4">
			{kpis.map((kpi) => (
				<div key={kpi.label} className="rounded-lg border bg-card p-4">
					<p className="text-xs text-muted-foreground">{kpi.label}</p>
					<p className="mt-1 text-2xl font-semibold">{kpi.value}</p>
					<p
						className={`mt-1 text-xs ${kpi.up ? 'text-green-600' : 'text-red-600'}`}
					>
						{kpi.up ? '↑' : '↓'} {kpi.delta}{' '}
						<span className="text-muted-foreground">vs prev</span>
					</p>
				</div>
			))}
		</div>
	);
}
